import { defineStore } from 'pinia';

export const useKycStore = defineStore('kyc', {
	state: () => ({
		// no_verification | unused | pending | completed_passed | completed_failed | native_form | error
		mode: null,
		form_url: null,
		verification_id: null,
		verification_attempts_left: null,
		decline_reasons: [],
		verifications_breakdown: {},
		document_summaries: [],
		required_verifications: [],
		completed_at: null,
		loading: true,
		error: null,
	}),
	actions: {
		loadStatus() {
			this.loading = true;
			this.error = null;
			return global.axios.get(process.env.VUE_APP_API_URL + '/account/kyc/status').then((response) => {
				this.applyResponse(response.data);
				this.loading = false;
				return response.data;
			}).catch((error) => {
				this.error = error.response?.data?.message || 'kyc_status_failed';
				this.mode = 'error';
				this.loading = false;
				return Promise.reject(error);
			});
		},
		start() {
			this.loading = true;
			this.error = null;
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/kyc/start').then((response) => {
				this.applyResponse(response.data);
				this.loading = false;
				return response.data;
			}).catch((error) => {
				this.error = error.response?.data?.message || 'kyc_start_failed';
				this.mode = 'error';
				this.loading = false;
				return Promise.reject(error);
			});
		},
		markSubmitted() {
			if (this.mode === 'unused') {
				this.mode = 'pending';
				this.form_url = null;
			}
		},
		receiveCompletionEvent(payload) {
			this.mode = payload.verified ? 'completed_passed' : 'completed_failed';
			this.verification_id = payload.provider_verification_id || this.verification_id;
			this.decline_reasons = payload.decline_reasons || [];
			this.form_url = null;
			this.loadStatus();
		},
		applyResponse(data) {
			this.mode = data.mode || 'error';
			this.form_url = data.url || null;
			this.verification_id = data.verification_id || null;
			this.verification_attempts_left = data.verification_attempts_left ?? null;
			this.decline_reasons = data.decline_reasons || [];
			this.verifications_breakdown = data.verifications_breakdown || {};
			this.document_summaries = data.document_summaries || [];
			this.required_verifications = data.required_verifications || [];
			this.completed_at = data.completed_at || null;
		},
	},
});
